import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { ParadiseOrderAmount } from "src/components/Paradise/ParadiseOrders/ParadiseOrderDetails/ParadiseOrderAmount"
import { ParadiseTable } from "src/components/Paradise/ParadiseTable"
import { chargebeeInvoiceUrl } from "src/constants/hrefs"
import { TParadiseOrder } from "src/data/paradise/paradiseOrders/paradiseOrderTypes"
import { ExternalLink } from "src/ui/Link/ExternalLink"
import { spacing } from "src/ui/spacing"

export function ParadiseOrderItems({ order }: { order: TParadiseOrder }) {
  const headers = [
    <div key={"item"}>Name</div>,
    <div key={"quantity"}>Quantity</div>,
    <div key={"unit-amount"}>Unit amount</div>,
    <div key={"amount"}>Amount</div>,
    <div key={"tax"}>Tax</div>,
    <div key={"discount"}>Discount</div>,
  ]

  const productLineItems = order.line_items.map((i) => (
    <>
      <div>
        <Text variant="subtitleS">{i.description}</Text>
        <DescriptionMeta>
          <Text variant="bodyS" color="secondary">
            SKU: {i.sku}
          </Text>
          •
          {i.product_id && (
            <Text variant="bodyS" color="secondary">
              {i.product_id}
            </Text>
          )}
        </DescriptionMeta>
      </div>
      <div>{i.quantity}</div>
      <div>{i.unit_price.formatted_amount}</div>
      <div>{i.price.formatted_amount}</div>
      <div>
        {i.tax.formatted_amount}{" "}
        {!!i.tax_exempt_reason ? `(${i.tax_exempt_reason})` : ""}
      </div>
      <div>{i.discount.formatted_amount}</div>
    </>
  ))

  const shippingLineItemRow = !!order.shipping_line_item ? (
    <>
      <div>
        <Text variant="subtitleS">{order.shipping_line_item.name}</Text>
      </div>
      <div>1</div>
      <div>{order.shipping_line_item.price.formatted_amount}</div>
      <div>{order.shipping_line_item.price.formatted_amount}</div>
      <div>{order.shipping_line_item.tax.formatted_amount}</div>
      <div>{order.shipping_line_item.discount.formatted_amount}</div>
    </>
  ) : null

  const rows = [...productLineItems, shippingLineItemRow].filter((i) => !!i)

  return (
    <div>
      <ParadiseDetailsSection
        title="Order line items"
        description={
          !!order.invoice_id && (
            <>
              The order line items that need fulfillment from the warehouse. To
              see all purchased items in the order (e.g. home tokens as well),
              open the{" "}
              <ExternalLink
                href={chargebeeInvoiceUrl(order.invoice_id)}
                showExternalIcon={false}
              >
                full invoice
              </ExternalLink>{" "}
              in Chargebee.
            </>
          )
        }
      >
        <ParadiseTable
          header={headers}
          rows={rows}
          templateColumns="3fr repeat(5, 1fr)"
        />
        <ParadiseOrderAmount
          totalPrice={order.total_price}
          tax={order.tax}
          vatNumber={order.vat_number}
        />
      </ParadiseDetailsSection>
    </div>
  )
}

const DescriptionMeta = styled.div`
  display: flex;
  gap: ${spacing.XS};
`
